import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import createSagaMonitor from "@clarketm/saga-monitor";
import { composeWithDevTools } from "redux-devtools-extension";
import { createStateSyncMiddleware } from "redux-state-sync";
import reducers from "./reducers";
import sagas from "./sagas";
import localforage from "localforage";

const persistConfig = {
  key: "primary",
  storage: localforage,
  debug: true
};

const persistedReducer = persistReducer(persistConfig, reducers);

// configuration
const sagaMonitorConfig = {
  level: "debug", // logging level
  verbose: true, // verbose mode
  color: "#03A9F4", // default color
  rootSagaStart: false, // show root saga start effect
  effectTrigger: false, // show triggered effects
  effectResolve: false, // show resolved effects
  effectReject: false, // show rejected effects
  effectCancel: false, // show cancelled effects
  actionDispatch: false // show dispatched actions
};

const sagaMiddleware = createSagaMiddleware({ sagaMonitor: createSagaMonitor(sagaMonitorConfig) });

const crosstabConfig = {
  whitelist: [
    "UPDATE_AUTHSTATE",
    "UPDATE_AUTHDATA",
    "UPDATE_PROFILE",
    "DELETE_PROFILE",
    "USER_PRIVILEGES_GET",
    "USER_PRIVILEGES_GET_SUCCESS",
    "USER_PRIVILEGES_GET_ERROR"
  ]
};

const middlewares = [createStateSyncMiddleware(crosstabConfig)];

const composeEnhancers = composeWithDevTools({
  // Specify here name, actionsBlacklist, actionsCreators and other options
});
// const store = createStore(reducers, composeEnhancers(applyMiddleware(...middlewares)));

export const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middlewares, sagaMiddleware)));
export const persistor = persistStore(store);

export default configureStore => {
  sagaMiddleware.run(sagas);
  return { store, persistor };
};
